import { createElement } from 'react';
import { render } from 'react-dom';
import {bannerComponentWrapper} from './banner-component-wrapper';
import * as loadableComponents from './loadable-components';
import { loadComponent } from './loader';
import SlotSwapper from './slot-swapper';

import { logError } from './log';

export const createReactComponentFromNode = (node, props) =>
  createElement(
    'span',
    { ...props, dangerouslySetInnerHTML: { __html: node.innerHTML } }
  );

export class CampaignRenderer {
  constructor ({ rootNode = global.document.body } = {}) {
    this.rootNode = rootNode;
    this.bannerMap = new WeakMap();
  }

  renderCampaign = async ({
    slotElement,
    slotProps,
    reactComponentName,
    renderProps,
    campaignName,
    campaignId,
    doNotTrack
  }) => {
    if (this.isSlotMounted(slotElement)) return;
    try {
      const loadedComponent = await loadComponent(loadableComponents[reactComponentName]);
      if (!loadedComponent) {
        // couldn't load component
        return;
      }
      if (!this.isDescendantOfRootNode(slotElement)) {
        // slotElement is not part of target subtree anymore
        return;
      }

      const BannerComponent = bannerComponentWrapper({
        BannerComponent: loadedComponent,
        campaignName,
        campaignId,
        doNotTrack,
        slotElement
      });
      const slotComponent = createReactComponentFromNode(
        slotElement,
        { key: 'slot' }
      );

      const marketingBanner = createElement(SlotSwapper(BannerComponent, renderProps, slotComponent));
      render(marketingBanner, slotElement);
    } catch (error) {
      // handle unexpected errors
      logError(error);
    }
  };

  isSlotMounted (node) {
    return this.bannerMap.has(node);
  }

  isDescendantOfRootNode = (node) => {
    return this.rootNode.contains(node);
  };
}
